import BaseServiceHttp from '../baseService'
class Autores extends BaseServiceHttp {
  constructor(id) {
    const resource = 'autores'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Autores(id)
